export const LOGIN_USER = 'LOGIN_USER'
export const USER_LOGGED_IN = 'USER_LOGGED_IN'
export const LOGOUT_USER = 'LOGOUT_USER'
export const USER_LOGIN_FAILED = 'USER_LOGIN_FAILED'
export const SET_AUTHENTICATED_USER = 'SET_AUTHENTICATED_USER'
export const GETTING_USER = 'GETTING_USER'
export const SET_API_AVAILABILITY = 'SET_API_AVAILABILITY'
export const SET_USER_FROM_COOKIE = 'SET_USER_FROM_COOKIE'



// WEBPACK FOOTER //
// ./resources/js/store/action-types.js